<template>
  <div v-if="template == 0" class="w-100">
    <div class="list-productos">
      <a class="item_kodemoon" :href="selected_product.href">
        <img
          :src="
            'https://pim.peralba.com/' +
              selected_product.product_images[0]?.thumbnail
          "
          class="min-width-200px"
          :alt="selected_product.name"
        />

        <div class="div-info">
          <div class="div-first d-flex">
            <div>
              <img
                :src="'/uploads/thumbnail-brands/' + product.brand.logo_image"
                class="logo_marca"
                :alt="product.brand.name"
                @error="setDefaultImage"
              />

              <h5 class="ref" v-if="selected_product.alias_code">
                REF:{{ selected_product.alias_code }}
              </h5>
              <h5 class="ref" v-else>
                REF:{{ selected_product.erp_reference }}
              </h5>
              <h4 class="desc">{{ selected_product.translation.name }}</h4>

              <div
                class="contenedor-disponibilidad"
                v-if="selected_product.available_stock"
              >
                <div class="stock">
                  <div
                    v-bind:class="selected_product.available_stock['status']"
                  ></div>
                  {{ selected_product.available_stock["text_ca"] }}
                </div>
                <div
                  v-if="
                    productUnits > 0 &&
                      selected_product.available_stock['stock_web'] > 0
                  "
                  style="display:flex"
                >
                  <button
                    type="button"
                    class="card-click-collect"
                    @click="openModalClickAndCollect"
                  >
                    {{ transPeralbaPro.item894 }}
                  </button>
                </div>
                <div
                  v-if="
                    productUnits > 0 &&
                      selected_product.available_stock['stock_web'] > 0
                  "
                >
                  <span class="text-warning">
                    {{ transPeralbaPro.item1180 }}
                    {{ selected_product.available_stock["stock_web"] }}
                  </span>
                </div>
              </div>
            </div>
            <div class="ms-auto">
              <template v-if="parseFloat(selected_product.discount_) > 0">
                <div class="container-pvp">
                  <p class="pvp-title">{{ transPeralbaPro.item132 }}</p>
                  <div class="d-flex">
                    <p class="pvp-value">
                      {{ selected_product.price_without_discount_ | currency }}
                    </p>
                    <span class="offer"
                      >-{{ selected_product.discount_ | percentage }}</span
                    >
                  </div>
                </div>
                <div class="container-offer">
                  <p class="pvp-title">{{ transPeralbaPro.item882 }}</p>
                  <p class="pvp-offer red">
                    {{ selected_product.price_ | currency }}
                  </p>
                </div>
              </template>
              <div class="container-offer" v-else>
                <p class="pvp-title">{{ transPeralbaPro.item132 }}</p>
                <p class="pvp-offer">{{ selected_product.price | currency }}</p>
              </div>
            </div>
          </div>

          <div class="row-atributos">
            <div class="atributo" v-for="(variation, index) in variations">
              <template v-if="variation.name.toLowerCase() != 'color'">
                <label>{{ variation.name }}</label>
                <div class="form-group">
                  <select
                    v-if="variation.available_values"
                    class="form-control attribute-value"
                    :id="'select-atrribute-' + variation.id"
                    @change="onChange($event, variation)"
                    v-model="variation.selected_variation"
                    @click.stop="clickSelect($event)"
                  >
                    <option
                      v-for="(available_value,
                      index2) in variation.available_values"
                      :value="available_value"
                      >{{ available_value.value }}</option
                    >
                  </select>
                  <span v-else>{{ variation.value }}</span>
                </div>
              </template>
              <template v-else>
                <label>{{ variation.name }}</label>
                <div class="container-colors mb-4">
                  <div
                    class="color-circle"
                    :class="
                      variation.selected_variation &&
                      variation.selected_variation.value_id ==
                        available_value.value_id
                        ? 'active'
                        : ''
                    "
                    v-for="(available_value,
                    index2) in variation.available_values"
                    @click="onChangeColor($event, variation, available_value)"
                  >
                    <div
                      class="content-circle"
                      v-bind:style="{
                        'background-color': available_value.info,
                      }"
                    ></div>
                  </div>
                </div>
              </template>
            </div>
          </div>

          <div class="row-bottom">
            <div class="unidades">
              <label>{{ transPeralbaPro.item895 }}</label>
              <div class="selector-unidades" @click.prevent="preventDefault">
                <button
                  @click="decUnits(selected_product)"
                  :class="
                    productUnits > 1 ||
                    (selected_product.minimum > 0 &&
                      productUnits > selected_product.minimum)
                      ? 'color-neutral-500'
                      : ''
                  "
                >
                  -
                </button>
                <div>
                  <input
                    :class="
                      selected_product.minimum > 0
                        ? 'only-decimal'
                        : 'only-number'
                    "
                    type="number"
                    class="cantidad-item"
                    :min="
                      selected_product.minimum > 0
                        ? selected_product.minimum
                        : 1
                    "
                    max="10000"
                    :step="
                      selected_product.minimum > 0
                        ? selected_product.minimum
                        : 1
                    "
                    :data-erp="selected_product.erp_reference"
                    @input="showBtn($event)"
                    v-on:keyup.enter="addToShoppingCart($event)"
                    v-model.number="productUnits"
                  />
                </div>
                <button
                  @click="incUnits(selected_product)"
                  class="color-neutral-500"
                >
                  +
                </button>
              </div>
            </div>
            <div v-if="canWriteOrders" class="add-cart w-100">
              <button
                class="btn-per-dark w-100"
                :disabled="loading"
                @click="addToShoppingCart($event)"
              >
                <img :src="'/front/hi/cart-white.svg'" class="icon-button" />{{
                  transPeralbaPro.item896
                }}
              </button>
            </div>
          </div>
        </div>
      </a>
    </div>
  </div>

  <div class="col-lg-4 col-md-4 col-6 p-0 grid-productos" v-else>
    <a class="item_kodemoon" :href="selected_product.href">
      <img
        :src="
          'https://pim.peralba.com/' +
            selected_product.product_images[0]?.thumbnail
        "
        class="kd-img"
        :alt="selected_product.name"
      />
      <img
        :src="'/uploads/thumbnail-brands/' + product.brand.logo_image"
        class="logo_marca"
        :alt="product.brand.name"
        @error="setDefaultImage"
      />
      <h5 class="ref" v-if="selected_product.alias_code">
        REF:{{ selected_product.alias_code }}
      </h5>
      <h5 class="ref" v-else>REF:{{ selected_product.erp_reference }}</h5>
      <h4 class="desc">{{ selected_product.translation.name }}</h4>

      <template v-if="selected_product.available_stock">
        <div class="contenedor-disponibilidad">
          <div class="stock">
            <div
              v-bind:class="selected_product.available_stock['status']"
            ></div>
            {{ selected_product.available_stock["text_ca"] }}
          </div>
        </div>
        <div
          v-if="productUnits > 0 && selected_product.available_stock['stock_web'] > 0"
          class="div-click-collect-grid mb-0"
        >
          <button
            type="button"
            class="card-click-collect"
            @click="openModalClickAndCollect"
          >
            {{ transPeralbaPro.item894 }}
          </button>
        </div>
        <div
          v-if="
            productUnits > 0 &&
              selected_product.available_stock['stock_web'] > 0
          "
        >
          <span class="text-warning">
            {{ transPeralbaPro.item1180 }}
            {{ selected_product.available_stock["stock_web"] }}
          </span>
        </div>
      </template>

      <div class="desktop-d-flex" v-if="parseFloat(selected_product.discount_) > 0">
        <div class="container-pvp">
          <p class="pvp-title">{{ transPeralbaPro.item132 }}</p>
          <div class="d-flex">
            <p class="pvp-value">
              {{ selected_product.price_without_discount_ | currency }}
            </p>
            <span class="offer"
              >-{{ selected_product.discount_ | percentage }}</span
            >
          </div>
        </div>
        <div class="container-offer">
          <p class="pvp-title">{{ transPeralbaPro.item882 }}</p>
          <p class="pvp-offer red">{{ selected_product.price_ | currency }}</p>
        </div>
      </div>
      <div class="container-offer" v-else>
        <p class="pvp-title">{{ transPeralbaPro.item132 }}</p>
        <p class="pvp-offer">{{ selected_product.price | currency }}</p>
      </div>
    </a>

    <div class="row-bottom to-bottom hide-desktop">
      <div class="unidades">
        <div class="selector-unidades" @click.prevent="preventDefault">
          <button
            @click="decUnits(selected_product)"
            :class="
              productUnits > 1 ||
              (selected_product.minimum > 0 &&
                productUnits > selected_product.minimum)
                ? 'color-neutral-500'
                : ''
            "
          >
            -
          </button>
          <div>
            <input
              :class="
                selected_product.minimum > 0
                  ? 'only-decimal'
                  : 'only-number'
              "
              type="number"
              class="cantidad-item"
              :min="
                selected_product.minimum > 0
                  ? selected_product.minimum
                  : 1
              "
              max="10000"
              :step="
                selected_product.minimum > 0
                  ? selected_product.minimum
                  : 1
              "
              :data-erp="selected_product.erp_reference"
              @input="showBtn($event)"
              v-on:keyup.enter="addToShoppingCart($event)"
              v-model.number="productUnits"
            />
          </div>
          <button
            @click="incUnits(selected_product)"
            class="color-neutral-500"
          >
            +
          </button>
        </div>
      </div>
      <div v-if="canWriteOrders" class="add-cart w-100">
        <button
          class="btn-per-dark w-100"
          :disabled="loading"
          @click="addToShoppingCart($event)"
        >
          <img :src="'/front/hi/cart-white.svg'" class="icon-button" />
          <span class="d-none d-md-inline">
            {{ transPeralbaPro.item1277 }}
          </span>
        </button>
      </div>
    </div>

  </div>
</template>
<script>
import axios from "axios";
export default {
  props: [
    "product",
    "user",
    "item24",
    "item25",
    "item26",
    "template",
    "mobile",
    "warehouse",
    "transPeralbaPro",
    "locale",
    "canWriteOrders",
  ],
  name: "product-item",
  data() {
    return {
      loading: false,
      productUnits: this.product.minimum > 0 ? this.product.minimum : 1,
      allProducts: [],
      variations: [],
      selected_product: this.product,
    };
  },
  filters: {
    currency(value) {
      return new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "EUR",
      }).format(value);
    },
    percentage(value) {
      if (parseInt(value) == parseFloat(value)) {
        return parseInt(value) + "%";
      } else {
        return parseFloat(value).toFixed(2) + "%";
      }
    },
  },
  mounted: function() {
    axios
      .get(
        "/" +
          this.locale +
          "/get-variation-products/" +
          this.selected_product.id
      )
      .then((r) => {
        this.allProducts = r.data.allProducts;
        this.variations = r.data.variations;

        var code = null;

        for (var i = 0; i < this.variations.length; i++) {
          this.variations[i].selected_variation = null;
          for (var j = 0; j < this.variations[i].available_values.length; j++) {
            let productCodesArray = this.variations[i].available_values[j]
              .product_codes;
            if (
              productCodesArray.includes(this.selected_product.erp_reference) ||
              productCodesArray.includes(this.selected_product.alias_code)
            ) {
              this.variations[i].selected_variation = this.variations[
                i
              ].available_values[j];
            }
          }
        }

        if (
          this.selected_product &&
          this.selected_product.erp_reference != null &&
          this.selected_product.erp_reference != ""
        ) {
          code = this.selected_product.erp_reference;
        }

        if (
          this.selected_product &&
          this.selected_product.alias_code != null &&
          this.selected_product.alias_code != ""
        ) {
          code = this.selected_product.alias_code;
        }

        // for (var i = 0; i < this.variations.length; i++) {
        //   this.variations[i].selected_variation = null;
        //   for (var j = 0; j < this.variations[i].available_values.length; j++) {
        //     if (
        //       this.variations[i].available_values[j].product_code ==
        //         this.selected_product.erp_reference ||
        //       this.variations[i].available_values[j].product_code ==
        //         this.selected_product.alias_code
        //     ) {
        //       code = this.variations[i].available_values[j].product_code;
        //       this.variations[i].selected_variation = this.variations[
        //         i
        //       ].available_values[j];
        //     }
        //   }
        // }

        if (code != null) {
          for (var i = 0; i < this.allProducts.length; i++) {
            if (
              this.allProducts[i].erp_reference == code ||
              this.allProducts[i].alias_code == code
            ) {
              this.selected_product.price_ = this.allProducts[i].price_;
              this.selected_product.discount_ = this.allProducts[i].discount_;
              this.selected_product.price_without_discount_ = this.allProducts[
                i
              ].price_without_discount_;
            }
          }
        } else {
          this.selected_product.price_ = this.allProducts[0].price_;
          this.selected_product.discount_ = this.allProducts[0].discount_;
          this.selected_product.price_without_discount_ = this.allProducts[0].price_without_discount_;
        }

        this.$forceUpdate();

        this.$nextTick(function() {});
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => (this.loading = false));
  },
  methods: {
    openModalClickAndCollect(event) {
      event.preventDefault();
      const modalElement = document.getElementById("modal-click-and-collect");
      if (modalElement) {
        const bootstrapModal = new bootstrap.Modal(modalElement);
        bootstrapModal.show();
      }
    },

    setDefaultImage(event) {
      event.target.src = "/front/img/brand/default-brand.png";
    },

    preventDefault(event) {
      event.preventDefault();
    },

    onChangeColor(e, variation2, available_value) {
      variation2.selected_variation = available_value;
      this.onChange(e, variation2);
    },

    onChange(e, variation) {
      e.stopPropagation();
      e.preventDefault();

      var productFound = false;

      for (var i = 0; i < this.allProducts.length; i++) {
        var attrFound = [];
        for (var k = 0; k < this.variations.length; k++) {
          attrFound.push(false);
        }
        for (var k = 0; k < this.variations.length; k++) {
          for (var j = 0; j < this.allProducts[i].characteristics.length; j++) {
            if (productFound == false) {
              var productCharacteristic = this.allProducts[i].characteristics[
                j
              ];
              if (
                productCharacteristic.attribute_id ==
                this.variations[k].selected_variation.attribute_id
              ) {
                if (
                  productCharacteristic.value ==
                  this.variations[k].selected_variation.value
                ) {
                  attrFound[k] = true;
                }
              }
              if (attrFound.every((value) => value === true)) {
                this.selected_product = this.allProducts[i];
                productFound = true;
              }
            }
          }
        }
      }

      if (productFound == false) {
        for (var i = 0; i < this.allProducts.length; i++) {
          if (
            this.allProducts[i].erp_reference ==
              variation.selected_variation.product_code ||
            this.allProducts[i].alias_code ==
              variation.selected_variation.product_code
          ) {
            this.selected_product = this.allProducts[i];
            for (var i = 0; i < this.variations.length; i++) {
              if (this.variations[i].attribute_id != variation.attribute_id) {
                // aquí tenim les altres variacions, diferents a la que ha canviat
                // així podrem comprobar que els valors d'aquestes siguin els del producte establert
                // en cas que no tinguin el mateix valor que el producte, les canviarem
                var changed = false;
                for (
                  var j = 0;
                  j < this.variations[i].available_values.length;
                  j++
                ) {
                  let productCodesArray = this.variations[i].available_values[j]
                    .product_codes;
                  if (
                    this.variations[i].available_values[j].product_code ==
                      this.selected_product.erp_reference ||
                    this.variations[i].available_values[j].product_code ==
                      this.selected_product.alias_code
                  ) {
                    changed = true;
                    this.variations[i].selected_variation = this.variations[
                      i
                    ].available_values[j];
                  }
                }
                if (changed == false) {
                  for (
                    var j = 0;
                    j < this.variations[i].available_values.length;
                    j++
                  ) {
                    let productCodesArray = this.variations[i].available_values[
                      j
                    ].product_codes;
                    if (
                      productCodesArray.includes(
                        this.selected_product.erp_reference
                      ) ||
                      productCodesArray.includes(
                        this.selected_product.alias_code
                      )
                    ) {
                      this.variations[i].selected_variation = this.variations[
                        i
                      ].available_values[j];
                    }
                  }
                }
              }
            }
            break;
          }
        }
      }
    },

    clickSelect(e) {
      e.stopPropagation();
      e.preventDefault();
    },

    incUnits(item) {
      if (
        this.productUnits == "" ||
        this.productUnits == undefined ||
        this.productUnits == 0
      ) {
        if (!isNaN(item.minimum) && parseFloat(item.minimum) > 0) {
          this.productUnits = parseFloat(item.minimum);
        } else {
          this.productUnits = 1;
        }
      } else {
        if (!isNaN(item.minimum) && parseFloat(item.minimum) > 0) {
          const minimum = parseFloat(item.minimum);
          const currentQuantity = parseFloat(this.productUnits);
          const remainder = currentQuantity % minimum; // Calcula el resto de la división
          if (remainder !== 0) {
            // Si la cantidad actual no es un múltiplo del mínimo, ajusta la cantidad
            this.productUnits += minimum - remainder;
          } else {
            // Si la cantidad actual ya es un múltiplo del mínimo, simplemente incrementa la cantidad
            this.productUnits += minimum;
          }
        } else {
          // Si no hay mínimo definido, incrementa la cantidad en 1
          this.productUnits++;
        }
      }
    },
    decUnits(item) {
      if (
        this.productUnits == "" ||
        this.productUnits == undefined ||
        this.productUnits == 0
      ) {
        if (!isNaN(item.minimum) && parseFloat(item.minimum) > 0) {
          this.productUnits = parseFloat(item.minimum);
        } else {
          this.productUnits = 1;
        }
      } else {
        if (!isNaN(item.minimum) && parseFloat(item.minimum) > 0) {
          const minimum = parseFloat(item.minimum);
          const currentQuantity = parseFloat(this.productUnits);
          const remainder = currentQuantity % minimum; // Calcula el resto de la división
          if (remainder !== 0) {
            // Si la cantidad actual no es un múltiplo del mínimo, ajusta la cantidad
            this.productUnits -= remainder;
          } else {
            // Si la cantidad actual ya es un múltiplo del mínimo, simplemente decrementa la cantidad
            this.productUnits -= minimum;
          }
          if (this.productUnits <= 0) {
            this.productUnits = item.minimum; // Asegúrate de que la cantidad no sea negativa
          }
        } else {
          // Si no hay mínimo definido, decrementa la cantidad en 1
          this.productUnits--;
          if (this.productUnits <= 0) {
            this.productUnits = 1; // Asegúrate de que la cantidad no sea negativa
          }
        }
      }
    },
    showBtn(event) {
      let showBtn = false;
      $(".quantity-elements").each(function(index) {
        $(this).removeClass("to-add");
        if ($(this).val() != "") {
          showBtn = true;
          $(this).addClass("to-add");
        }
      });
      if (showBtn) {
        $("#add-multiple-products").removeClass("d-none");
      } else {
        $("#add-multiple-products").addClass("d-none");
      }
    },
    showStocks() {
      let formData = {
        product_id: this.selected_product.id,
      };
      axios
        .post("/show-stocks", formData)
        .then((r) => {
          if (r.data.status == 1) {
            $("#modal-content").html(r.data.view);
            $("#modal-stock")
              .appendTo("body")
              .modal("show");
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => (this.loading = false));
    },
    fmod(x, y) {
      let i = parseInt(x * 100);
      let mod = parseInt(y * 100);
      let parsed = (i % mod) / 100;
      return parsed;
    },
    addToShoppingCart(event) {
      event.preventDefault();
      let quantity = parseFloat(this.productUnits);
      let minimum = parseFloat(this.selected_product.minimum);
      let element = "";
      quantity = parseFloat(quantity);
      if (this.loading) {
        return;
      }
      this.loading = true;

      if (minimum > 0 && this.fmod(quantity, minimum) > 0) {
        swal({
          title:
            "Este producto solo puede venderse de " +
            minimum +
            " en " +
            minimum +
            " uds",
          text: " ",
          type: "warning",
          customClass: "swal-wide",
          timer: 2000,
          showConfirmButton: false,
        });
        this.loading = false;
        return false;
      }

      let formData = {
        quantity: quantity,
        product_id: this.selected_product.id,
      };
      axios
        .post("/" + this.locale + "/add-shopping-cart-product", formData)
        .then((r) => {
          if (r.data.status == 1) {
            Array.prototype.forEach.call($(".number-cart"), function(el) {
              el.innerText = r.data.quantity_cart;
            });
            if (r.data.quantity_cart > 0) {
              Array.prototype.forEach.call($(".number-cart"), function(el) {
                el.classList.remove("d-none");
              });
            }
            this.$emit("product-added", this.selected_product);
          } else {
            throwNotify("{{trans('Peralba Pro.item568')}}", "warning", 1000);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => (this.loading = false));

      axios
        .get("/get-selled-together/" + this.selected_product.id)
        .then((r) => {
          if (r.data.status == 1) {
            this.$emit("selled-products", r.data.selledProducts);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => (this.loading = false));
    },
    throwNotify(title, type, timer, text) {
      if (typeof text == "undefined") {
        text = " ";
      }
      swal({
        title: title,
        text: text,
        type: type,
        timer: timer,
      });
    },
  },
};
</script>
